import { HttpResponse } from "@aspnet/signalr";
import http from "../http-common";
export default class UserServices {
  async getAll(company_id) {
    let res = await http.get(`v1/user?companyId=${company_id}`);
    return res.data;
  }

  async getAllActive(company_id) {
    let res = await http.get(`v1/user/active?companyId=${company_id}`);
    return res.data;
  }

  async getAllExternal(company_id) {
    let res = await http.get(`v1/user/external?companyId=${company_id}`);
    return res.data;
  }

  async getPaper(company_id) {
    let res = await http.get(`v1/user/${company_id}/paper`);
    return res.data;
  }

  async getAllUserPaperOfSupervisor(company_id) {
    let res = await http.get(`v1/user/${company_id}/supervisor`);
    return res.data;
  }

  async getOnlineUsers(company_id) {
    let res = await http.get(`v1/user/online?companyId=${company_id}`);
    return res.data;
  }

  async save(user) {
    let res = await http.post(`v1/user`, user);
    return res.data;
  }

  async edit(user) {
    let res = await http.put(`v1/user/${user.id_usuario}`, user);
    return res.data;
  }

  async search(id_user) {
    let res = await http.get(`v1/user/${id_user}`);
    return res.data;
  }

  async disableAndEnableUser(id_user, id_status) {
    let res = await http.delete(`v1/user/${id_user}/${id_status}`);
    return res.data;
  }

  async deleteUser(id_user) {
    let res = await http.delete(`v1/user/delete/${id_user}`);
    return res.data;
  }

  async transferAttendanceToQueueWait(id_user) {
    let res = await http.post(
      `v1/user/${id_user}/transfer-attendance-to-queue-wait`
    );
    return res.data;
  }

  async changeStatus(code_status, motivePause) {
    let res = await http.post(
      `v1/user/${code_status}/change-status?motivePause=${motivePause}`
    );
    return res.data;
  }

  async getTourVisto(user_id) {
    let res = await http.get(`v1/user/${user_id}/tour-visto`);
    return res.data;
  }

  async setTourVisto(user_id, visto) {
    let res = await http.put(`v1/user/${user_id}/tour-visto?visto=${visto}`);
    return res.data;
  }

  async getLogStatus() {
    let res = await http.post(`v1/user/get-log-status`);
    return res.data;
  }

  async Logout() {
    let res = await http.post(`v1/user/logout`);
    return res.data;
  }

  async AddUserBatch(user_batch) {
    let res = await http.post(`v1/user/batch`, user_batch);
    return res.data;
  }

  async getUserExcel(company_id) {
    let res = await http.get(`v1/user/export?companyId=${company_id}`, {
      responseType: "blob",
    });
    return res.data;
  }

  async updatePassword(userId, passwords) {
    let res = await http.put(`v1/user/update-password/${userId}`, passwords);
    return res.data;
  }

  async updateFirstLoginPassword(userId, userdata, token) {
    let res = await http.put(
      `v1/user/update-first-login-password/${userId}`,
      userdata,
      token ? { headers: { Authorization: `Bearer ${token}` } } : undefined
    );
    return res.data;
  }

  async getDailyPauses() {
    let res = await http.get(`v1/user/get-today-pauses`);
    return res.data;
  }

  async updateIpAndMachineName(userId, payload) {
    await http.put(`v1/user/update-ip/${userId}`, payload);
  }

  async coletarIpLocal() {
    try {
      const res = await fetch(`${process.env.VUE_APP_TRAY_API_URL_HTTPS}/api/get-ip`);
      if (!res.ok) throw new Error(`Erro: ${res.status}`);
      return await res.json();
    } catch (err) {
      throw err;
    }
  }

  async saveInfoMachine(userId) {
    const baseUrl = process.env.VUE_APP_BASE_URL;
    const endpoint = "api/v1/user/update-ip";

    const protocolo =
      `ipreporter://?token=${encodeURIComponent(
        localStorage.getItem("token_plataforma_digital")
      )}` +
      `&tenant=${encodeURIComponent(process.env.VUE_APP_TENANT)}` +
      `&userId=${encodeURIComponent(userId)}` +
      `&urlbase=${encodeURIComponent(baseUrl)}` +
      `&endpoint=${encodeURIComponent(endpoint)}`;

    window.location.href = protocolo;
    //console.log("protocolo" + protocolo);
  }

  async importarLote(arquivo) {
    const formData = new FormData();
    formData.append("arquivo", arquivo);

    return await http.post("v1/user/importar", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }
}